export default "__VITE_ASSET__CaBdNX9b__"